import { cx, styled } from "simplydo/react/styled";

import type { PlaceholderParagraphProps } from "./Placeholder.types";
import { PlaceholderLine } from "./PlaceholderLine";

const Paragraph = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;

  margin: 0 0 1em;

  &:last-child {
    margin-bottom: 0;
  }

  ${PlaceholderLine} {
    margin: ${({ $gap }) => $gap || 0.4}em 0;
  }
`;

const PlaceholderParagraphComponent = (props: PlaceholderParagraphProps) => {
  const { children, className, style, gap } = props;
  return (
    <Paragraph className={cx(className)} style={style} $gap={gap}>
      {children}
    </Paragraph>
  );
};

export const PlaceholderParagraph = styled(PlaceholderParagraphComponent)``;
